import { newToolFilterOAuthMcp } from "../oauth.ts";

export const udemyBusinessMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://frontends.udemycdn.com/staticx/udemy/images/v7/apple-touch-icon.png",
  url: "https://api.udemy.com/mcp",
  label: "Udemy Business",
});
